import c from '../skills/c.webp';
import bootstrap from '../skills/bootstrap.svg';

import cpp from '../skills/cpp.webp';
import css from '../skills/css.webp';
import django from '../skills/django.webp';
import express from '../skills/express.webp';

import html from '../skills/html.webp';
import java from '../skills/java.webp';
import js from '../skills/js.webp';
import node from '../skills/node.svg';
import python from '../skills/python.webp';
import react from '../skills/react.webp';
import sql from '../skills/sql.webp';
import firebaseRealtime from '../skills/firebaseRealtime.webp';
import firebaseFireStore from '../skills/firebaseFireStore.webp';

import mySql from '../skills/mySql.webp';
import mongoDb from '../skills/mongoDb.webp';

export const programming = [
  { title: 'JavaScript', img: js, rating: 4 },
  { title: 'Cpp', img: cpp, rating: 3 },
  { title: 'Python', img: python, rating: 3 },
  { title: 'Sql', img: sql, rating: 3 },
  { title: 'Java', img: java, rating: 2 },
  { title: 'C', img: c, rating: 1 },
];
export const webDev = [
  { title: 'JavaScript', img: js, rating: 4 },
  { title: 'React JS', img: react, rating: 4 },
  { title: 'HTML', img: html, rating: 3 },
  { title: 'CSS', img: css, rating: 3 },
  { title: 'Django', img: django, rating: 2 },
  { title: 'BootStrap', img: bootstrap, rating: 3 },
  { title: 'Node', img: node, rating: 3 },
  { title: 'Express', img: express, rating: 2 },
];

export const database = [
  { title: 'Firebase Firestore', img: firebaseFireStore, rating: 4 },
  { title: 'My Sql', img: mySql, rating: 2 },
  { title: 'Firebase Realtime Database', img: firebaseRealtime, rating: 3 },
  { title: 'Mongo Db', img: mongoDb, rating: 2 },
];
